// Lightweight singleton exposing the currently-logged-in viewer's role and id.
// Populated by KingdomConnect immediately after successful login and cleared on
// logout. Consumed by cross-cutting UI (Avatar rings, guards) that shouldn't
// require prop-drilling.

let _viewer = null;
const _subs = new Set();

export function setViewer(u) {
  _viewer = u || null;
  _subs.forEach(fn => { try { fn(_viewer); } catch (_) { /* ignore */ } });
}

export function getViewer() { return _viewer; }

export function getViewerRole() { return _viewer?.role || null; }

export function subscribeViewer(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}
